import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M32 16c0 8.846-7.154 16-16 16S0 24.846 0 16 7.154 0 16 0s16 7.154 16 16M16 2.057C8.274 2.057 2.057 8.343 2.057 16c0 7.726 6.286 13.943 13.943 13.943 7.726 0 13.943-6.286 13.943-13.943 0-7.726-6.286-13.943-13.943-13.943m-.914 15.84a.8.8 0 0 1-.32-.64V6.971c0-.434.366-.777.777-.777h.914c.411 0 .777.343.777.777v9.44l4.549 3.314a.767.767 0 0 1 .16 1.074l-.526.731c-.251.343-.731.411-1.097.16z" }, null, -1)
  ])))
}
export default { render: render }